import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { HelperService, HTTPService, ValidationService } from 'app/services';
import { DataService } from 'app/services/data.service';

import { contact, phoneTypes } from 'app/constants/customer';

import { find } from 'lodash';

@Component({
  selector: 'app-update-contact-dialog',
  templateUrl: './update-contact-dialog.component.html',
  styleUrls: ['./update-contact-dialog.component.scss'],
  providers: [DialogService],
})
export class UpdateContactDialogComponent implements OnInit {
  isProcessing: boolean = false;
  emails: any[] = [];
  phones: any[] = [];
  isFleetCustomer: boolean = false;
  phoneLength: any = 5;
  emailLength: any = 5;
  showHidePhone: boolean = true;
  showHideEmail: boolean = true;
  phoneTypes = phoneTypes;
  errors = {
    emails: {},
    phones: {},
  };
  primaryEmail: string = '';
  primaryPhone: string = '';
  contact: any = {};
  isMarketingEnabled: boolean = false;
  isMarketingOptOutEnabled: boolean = false;
  contactEntityId: string = '';
  contactEntityType: string = 'customer'; // customer | supplier
  supplierData: any = {};
  dropdownActive: boolean = false;
  prefrenceType: any;
  isUpdating: boolean = false;
  isMFCustomer: boolean = false;
  contactValidation = {
    email: {
      tooltip: '',
      icon: '',
    },
    phone: {
      tooltip: '',
      icon: '',
    },
  };
  isMarketingNotifEnabled: boolean = false;
  isOperationalNotifEnabled: boolean = false;
  hasOverriddenMarketingSwitch: boolean = false;
  hasOverriddenOperationalSwitch: boolean = false;


  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    private validationService: ValidationService,
    private dataService: DataService,
  ) { }

  ngOnInit() {
    const { contact, isFleetCustomer, email = '', phone = '', contactEntityId, contactEntityType = 'customer', supplierData, prefrenceType, isMFCustomer } = this.dynamicDialogConfig.data;

    this.contact = contact;
    this.isFleetCustomer = isFleetCustomer;
    this.primaryEmail = email;
    this.primaryPhone = phone;
    this.contactEntityId = contactEntityId;
    this.contactEntityType = contactEntityType;
    this.supplierData = supplierData;
    this.prefrenceType = prefrenceType;
    this.isMFCustomer = isMFCustomer;

    this.getCustomerContacts();

    if (this.contactEntityType === 'customer') {
      this.getCustomer(this.contactEntityId);
    }

    this.isMarketingEnabled = this.dataService.isMarketingEnabled;
    this.isMarketingOptOutEnabled = this.dataService.isMarketingOptOutEnabled;

    if (this.isMarketingOptOutEnabled) {
      const dialogCont = document.querySelector('.update-contact-dialog');

      if (dialogCont) {
        dialogCont.classList.add('marketing-opt-in');
      }
    }

    this.setContactValidation();
  }

  getCustomer(customerId: string) {
    this.httpService
      .getCustomer(customerId, {
        selectedField: 'isMFCustomer',
      })
      .then(
        (customer) => {
          this.isMFCustomer = customer.isMFCustomer && this.isFleetCustomer;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
  }

  getCustomerContacts() {
    if (!this.isFleetCustomer) {
      this.showHideEmail = false;
      this.showHidePhone = false;
    }

    if (!this.contactEntityId || !this.contact || !this.contact?.contactInfo?.length) return;

    const contactInfo = this.contact.contactInfo;

    const primaryEmailContact = contactInfo.find(
      (c) => c.contactType === 'email' && c.isPrimary
    );
    const primaryPhoneContact = contactInfo.find(
      (c) => c.contactType === 'mobile' && c.isPrimary
    );

    this.isMarketingNotifEnabled =
      primaryPhoneContact?.isMarketingNotifEnabled ??
      primaryEmailContact?.isMarketingNotifEnabled ??
      false;

    this.isOperationalNotifEnabled =
      primaryPhoneContact?.isOperationalNotifEnabled ??
      primaryEmailContact?.isOperationalNotifEnabled ??
      false;

    contactInfo.forEach((contactInfo: any) => {
      const contact = { ...contactInfo };

      // ✅ Sync initial flags from component-level to contact (ONLY if not overridden by user)
      // if (!this.hasOverriddenMarketingSwitch && contact.isPrimary) {
      //   contact.isMarketingNotifEnabled = this.isMarketingNotifEnabled;
      // }

      // if (!this.hasOverriddenOperationalSwitch && contact.isPrimary) {
      //   contact.isOperationalNotifEnabled = this.isOperationalNotifEnabled;
      // }

      if (contact.contactType === 'email') {
        contact.contactType = { label: 'Email', value: 'email' };

        if (contact.isPrimary && this.primaryEmail) {
          contact.value = this.primaryEmail;
        }

        this.emails.push(contact);
        this.sortArrayByPrimary(this.emails);
        if (this.emails.length > 5) {
          this.showHideEmail = false;
        }
      } else {
        contact.contactType = find(this.phoneTypes, {
          value: contact.contactType,
        });

        if (contact.isPrimary && this.primaryPhone) {
          contact.value = this.helperService.removePhoneFormatting(contact.value);
        }

        this.phones.push(contact);
        this.sortArrayByPrimary(this.phones);
        if (this.phones.length > 5) {
          this.showHidePhone = false;
        }
      }
    });
  }



  sortArrayByPrimary(value: any): void {
    value.sort((a, b) => {
      return a.isPrimary === b.isPrimary ? 0 : a.isPrimary ? -1 : 1;
    });
  }

  handleDeleteContact(type: string, index: string) {
    this[type].splice(index, 1);
  }

  seeMore(type: string) {
    if (type === 'phone') {
      this.phoneLength = this.phones.length;
      this.showHidePhone = true;
    }
    if (type === 'email') {
      this.emailLength = this.emails.length;
      this.showHideEmail = true;
    }
  }

  handleFocus(value) {
    if (this.phones.length < 4) {
      this.dropdownActive = value;
    }
  }

  handleMultiChange(type: string, key: string, index: number, value: any) {
    const contact = this[type][index];
    contact[key] = value;

    if (index === 0) {
      if (key === 'isMarketingNotifEnabled') {
        this.isMarketingNotifEnabled = value;
        this.hasOverriddenMarketingSwitch = true;
      }
      if (key === 'isOperationalNotifEnabled') {
        this.isOperationalNotifEnabled = value;
        this.hasOverriddenOperationalSwitch = true;
      }
    }

    // Update UI sync
    if (!this.hasOverriddenMarketingSwitch && key === 'isMarketingNotifEnabled') {
      this[type][0].isMarketingNotifEnabled = this.isMarketingNotifEnabled;
    }

    if (!this.hasOverriddenOperationalSwitch && key === 'isOperationalNotifEnabled') {
      this[type][0].isOperationalNotifEnabled = this.isOperationalNotifEnabled;
    }

    if (this.dropdownActive) {
      this.dropdownActive = !this.dropdownActive;
    }

    if (value && type === 'phones' && key === 'contactType') {
      if (value.value === 'landline') {
        this.phones[index].isPrimary = false;
      }

      if (!this.phones.filter(({ isPrimary }) => isPrimary).length) {
        for (let i = 0; i < this.phones.length; i++) {
          const phone = this.phones[i];

          if (phone.value && phone.contactType && phone.contactType.value === 'mobile') {
            this.phones[i].isPrimary = true;
            break;
          }
        }
      }
    } else if (key === 'isPrimary') {
      if (value) {
        this[type].forEach((contact: any, i: number) => {
          if (index !== i) {
            this[type][i].isPrimary = false;
          }
        });
      } else {
        const primaryIndex = this[type].findIndex((contact: any) => contact.isPrimary);
        if (primaryIndex === -1) {
          this[type][0].isPrimary = true;
        }
      }
    }
  }

  handleBlur(name: string) {
    this.setContactValidation();
  }

  handleAddAnother(type: string) {
    if ((!this.isMFCustomer && this.isFleetCustomer) || this.contactEntityType === 'supplier') {
      if (type === 'email') {
        // && this.emails.length < 5
        this.emails.push({
          ...this.helperService.deepCopy(contact),
          isPrimary: this.emails.length === 0,
          contactType: { label: 'Email', value: 'email' },
        });
        this.sortArrayByPrimary(this.emails);
        this.emailLength = this.emails.length;
      } else if (type === 'phone') {
        //  && this.phones.length < 5
        this.phones.push({
          ...this.helperService.deepCopy(contact),
          isPrimary: this.phones.filter(({ contactType }) => contactType && contactType.value === 'mobile').length === 0,
          contactType: { label: 'Mobile', value: 'mobile' },
        });
        this.sortArrayByPrimary(this.phones);
        this.phoneLength = this.phones.length;
      }
    } else {
      if (!this.isMFCustomer) {
        if (type === 'email' && this.emails.length < 5) {
          this.emails.push({
            ...this.helperService.deepCopy(contact),
            isPrimary: this.emails.length === 0,
            contactType: { label: 'Email', value: 'email' },
          });
          this.sortArrayByPrimary(this.emails);
          this.emailLength = this.emails.length;
        } else if (type === 'phone' && this.phones.length < 5) {
          this.phones.push({
            ...this.helperService.deepCopy(contact),
            isPrimary: this.phones.filter(({ contactType }) => contactType && contactType.value === 'mobile').length === 0,
            contactType: { label: 'Mobile', value: 'mobile' },
          });
          this.sortArrayByPrimary(this.phones);
          this.phoneLength = this.phones.length;
        }
      }
    }
  }

  isValid() {
    let isFormValid = true;
    this.errors = {
      emails: {},
      phones: {},
    };

    if (this.emails && this.emails.length) {
      const emails = [];
      this.emails.forEach((email: any, index: number) => {
        if (email && email.value && email.value.value) {
          this.emails[index].value = email.value.value;
        }
        this.errors.emails[index] = {};

        if (!this.isMFCustomer && emails.includes(email.value)) {
          this.errors.emails[index].value = `Add a unique email`;
          isFormValid = false;
        }

        if (email.value) {
          if (email.value && !this.validationService.validateEmail(email.value)) {
            this.errors.emails[index].value = 'Email is not valid';
            isFormValid = false;
          }

          emails.push(email.value);
        }
      });
    }

    if (this.phones && this.phones.length) {
      const phones = [];

      this.phones.forEach((phone: any, index: number) => {
        this.errors.phones[index] = {};
        phone.value = this.helperService.removePhoneFormatting(phone.value);

        if (!this.isMFCustomer && phones.includes(phone.value)) {
          this.errors.phones[index].value = `Add a unique number`;
          isFormValid = false;
        }

        if (phone.value) {
          if ((phone.value || '').length < 10) {
            this.errors.phones[index].value = `Phone is not valid`;
            //`Cell number isn't valid (000) 000-0000`;
            isFormValid = false;
          }

          phones.push(phone.value);
        }
      });
    }

    return isFormValid;
  }

  handleClose() {
    this.dynamicDialogRef.close({ isSuccess: false });
  }

  makeContactObject() {
    let contacts = [];

    contacts = this.helperService.deepCopy([
      ...this.emails.filter(({ value }) => value),
      ...this.phones.filter(({ value }) => value),
    ]);

    contacts = contacts.map((contact: any) => {
      contact.contactType = (contact.contactType && contact.contactType.value) || '';

      if (['mobile', 'landline'].includes(contact.contactType)) {
        contact.value = this.helperService.removePhoneFormatting(contact.value);
      }

      // ✅ REMOVE top-level fallback — only rely on per-contact switches
      // delete contact.isMarketingNotifEnabled;
      // delete contact.isOperationalNotifEnabled;

      return contact;
    });

    return contacts;
  }



  handleSave() {
    if (!this.isValid() || this.isProcessing) return;
    this.isProcessing = true;
    this.httpService
      .updateContacts(this.contactEntityId, { contacts: this.makeContactObject() })
      .then(
        ({ customer, contact }) => {
          this.dataService.sendData(
            this.dataService.typePassData('contact-update-modal', {
              isSuccess: true,
              customer: customer,
              type: 'passdata',
              component: 'contact-update-modal',
            }),
          );

          // Here we are sending the only contacts in estimate component to update contactInfo
          this.dataService.sendData(
            this.dataService.typePassData('customer-for-estimate', {
              contact: contact,
            }),
          );

          this.dynamicDialogRef.close({
            isSuccess: true,
            data: { customer: customer, contact },
          });
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isProcessing = false;
      });
  }

  handleTooltipClass(type: string = '') {
    const phone = this.phones.find((phone) => phone.isPrimary && this.helperService.removePhoneFormatting(phone.value));
    const email = this.emails.find((email) => email.isPrimary && email.value);
    if ((type === 'phone' && !phone) || (type === 'email' && !email)) {
      return `fal fa-exclamation-triangle font-13 warning-800 font-500 ml-1`;
    }
  }

  async handleChange(prefrence, value) {
    if (this.isUpdating) {
      return;
    }
    this.isUpdating = true;
    this.prefrenceType[prefrence] = value;
    try {
      const updatedData = await this.httpService.updateCommunicationPreference(this.contactEntityId, this.prefrenceType);
      if (updatedData) {
        this.isUpdating = false;
        this.helperService.showToaster('success', 'Preferences updated');
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
      this.isUpdating = false;
    }
  }

  setContactValidation() {
    // const phone = this.customer.phone;
    // const email = this.customer.email;
    const phone = this.phones.find(({ isPrimary, value }) => isPrimary && value);
    const email = this.emails.find(({ isPrimary, value }) => isPrimary && value);

    this.contactValidation = {
      email: {
        tooltip: '',
        icon: '',
      },
      phone: {
        tooltip: '',
        icon: '',
      },
    };

    if (!email) {
      if (this.dataService.customerMandatoryFields.email) {
        this.contactValidation.email = {
          icon: 'fal fa-exclamation-triangle font-13 primary-contact-danger',
          tooltip: 'Email is a required field',
        };
      } else {
        this.contactValidation.email = {
          icon: 'fal fa-exclamation-triangle font-13 primary-contact',
          tooltip: 'Adding email is recommended',
        };
      }
    }

    if (!phone) {
      if (this.dataService.customerMandatoryFields.mobile) {
        this.contactValidation.phone = {
          icon: 'fal fa-exclamation-triangle font-13 primary-contact-danger',
          tooltip: 'Phone number is a required field',
        };
      } else {
        this.contactValidation.phone = {
          icon: 'fal fa-exclamation-triangle font-13 primary-contact',
          tooltip: 'Adding phone is recommended',
        };
      }
    }
  }
}
